import { setCopyJobLinkWarningModal } from '../../store/workspace/slice';
import { ShareSquareIcon } from '../../assets/icons';
import { useDispatch } from '../../store/store';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function CopyJobLinkWarning() {
    const dispatch = useDispatch();

    const dismissFunc = () => {
        dispatch(setCopyJobLinkWarningModal(false));
    };

    const dismissAndDontShowAgainFunc = () => {
        dismissFunc();
        localStorage.setItem('copyJobLinkWarningDismissed', 'true');
    };

    return (
        <Modal
            size='md'
            title='Copy job link'
            icon={<ShareSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={dismissFunc}
        >
            <p>
                Using this link will display the applicant’s data
                only inside MeritFinder. The information will not appear
                in <b>Ashby</b>, as the applicant may not have an <b>Ashby</b> account.
            </p>
            <div className={styles.actions}>
                <Button
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    text='Don’t show this message again'
                    onClick={dismissAndDontShowAgainFunc}
                />
                <Button
                    type='Primary'
                    onClick={dismissFunc}
                    text='Continue with link copied'
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
